module.exports = __webpack_public_path__ + "static/media/sports02.e9dadacf.jpg";